<template>
    <div class="panel panel-default" data-testid="order-detail-beestore">
        <div class="panel-heading">
            <h4>{{ label }}</h4>
        </div>
        <div class="panel-body od-stack">
            <template v-if="order.beeStore && order.beeStore.reservationId">
                <div class="od-field">
                    <p class="od-field__label">ID prenotazione</p>
                    <od-mono-pill :value="String(order.beeStore.reservationId)" />
                </div>
                <od-key-value-list
                    :items="[{ label: 'Deposito', value: order.beeStore.depositFormatted || '—', align: 'right', strong: true }]"
                />
            </template>
            <p v-else class="text-muted od-empty-inline">Nessun dato BeeStore.</p>
        </div>
    </div>
</template>

<script>
import OdKeyValueList from './OdKeyValueList.vue';
import OdMonoPill from './OdMonoPill.vue';

export default {
    name: 'OrderBeeStoreCard',
    components: { OdKeyValueList, OdMonoPill },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        label() {
            return this.order.ui?.labels?.beeStore || 'BeeStore';
        },
    },
};
</script>
